// extracted by mini-css-extract-plugin
export var avatarContainer = "_15-0";
export var avatarTypingWave = "_15-i";
export var gray = "_15-f";
export var green = "_15-c";
export var icon = "_15-9";
export var image = "_15-1";
export var lg = "_15-6";
export var md = "_15-5";
export var presenceDot = "_15-b";
export var red = "_15-d";
export var sm = "_15-4";
export var status = "_15-a";
export var typingDot = "_15-h";
export var typingPill = "_15-g";
export var xl = "_15-7";
export var xs = "_15-3";
export var xxl = "_15-8";
export var xxs = "_15-2";
export var yellow = "_15-e";